// extracted by mini-css-extract-plugin
module.exports = {"bellButton":"NotificationBell_bellButton__A_vFr","badge":"NotificationBell_badge__Njzmx"};